export enum OrgType {
    AUTOMATED = 'Automated',
    FIXED = 'Fixed',
}
